// @flow

import { useState, useCallback } from 'react';
import { type PaymentSpec } from '@tectonics/prs/payment-spec';
import { type PaymentMethod, type PaymentMethodCode } from '@tectonics/prs/payment-method';

export function useSelectedPaymentMethod(spec: PaymentSpec): [?PaymentMethod, (PaymentMethodCode) => void] {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<?PaymentMethod>(null);

  const setSelectedPaymentMethodByCode = useCallback(
    (code: PaymentMethodCode) => {
      setSelectedPaymentMethod(spec.paymentMethods.find(paymentMethod => paymentMethod.code === code));
    },
    [spec, setSelectedPaymentMethod],
  );

  return [selectedPaymentMethod, setSelectedPaymentMethodByCode];
}
